<div class="td-wb-goal-selector__container">
  <td-wb-dropdown class="td-wb-goal-selector__dropdown"
                  id="td-wb-dropdown-goal-selector"
                  [panelMaxHeight]="310"
                  [ariaLabel]="'tdWb.lti.goalSelection.placeholder.GOAL_NAME' | translate"
                  [ngModel]="value ?? goal()"
                  [disabled]="isDisabled()"
                  (ngModelChange)="onModelChange($event)"
                  [comparator]="comparator">
    <td-wb-dropdown-toggle>
      <span [innerHtml]="selectedGoalName()"></span>
    </td-wb-dropdown-toggle>
    @for (goal of goals(); track goal) {
      <td-wb-dropdown-item [value]="goal">
        <span [innerHtml]="goal.name"></span>
      </td-wb-dropdown-item>
    }
  </td-wb-dropdown>
</div>
